import { PATH } from '../../app.type';

export const links = [
  { title: 'Strona główna', to: PATH.HOME },
  { title: 'Usługi', to: PATH.SERVICES },
  { title: 'Samochody', to: PATH.VEHICLES },
  { title: 'Cennik', to: PATH.PRICE_LIST },
  { title: 'Kontakt', to: PATH.CONTACT },
];
